import CloudProviders from '@/pages/admin/settings/cloud_provider/CloudProvider';
import APIKey from '@/pages/admin/settings/apikey';
import { Tabs, Tab } from '@/components/Tab';
import OrgSettings from '@/pages/admin/settings/org_settings';
import { useSearchParams } from 'react-router-dom';
import { useFeatureFlagEnabled } from '@/hooks/useFeatureFlag';
import { usePageViewed } from '@/hooks/usePageViewed';
import { toSettingsTabSelected } from '@/utils/analytics/taxonomy';

export default function Settings() {
  const [searchParams, setSearchParams] = useSearchParams();
  const enableAPIKey = useFeatureFlagEnabled('api-key');
  const enableCloudProvider = useFeatureFlagEnabled('private-cloud-provider');
  const activeTab = searchParams.get('tab') || 'org_settings';

  usePageViewed({
    page_name: 'settings',
    tab_selected: toSettingsTabSelected(activeTab),
  });

  return (
    <Tabs
      activeKey={searchParams.get('tab') || 'org_settings'}
      onChange={({ activeKey }) => {
        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.set('tab', `${activeKey}`);
        setSearchParams(newSearchParams, { replace: true });
      }}
      activateOnFocus
      overrides={{
        TabList: {
          style: {
            paddingTop: '16px',
          },
        },
      }}
    >
      <Tab title="Organization Settings" key="org_settings">
        <OrgSettings />
      </Tab>
      {enableCloudProvider && (
        <Tab title="Cloud Providers" key="cloud_providers">
          <CloudProviders />
        </Tab>
      )}
      {enableAPIKey && (
        <Tab title="API Keys" key="api_key">
          <APIKey />
        </Tab>
      )}
    </Tabs>
  );
}
